import type { MenuProps } from 'antd';

export enum CardMoreOperateKey {
  MUTE = 'mute',
  WATCH = 'watch',
  PIN = 'pin',
  HOST = 'host',
  CO_HOST = 'coHost',
  FULL_SCREEN = 'fullScreen',
  EDIT = 'edit',
}

export interface CardMoreOperateProps {
  children: ReactNode;
  className?: ClassNames;
  onClick: MenuProps['onClick'];
}
